import script from "./LaputaContactMe.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaContactMe.vue?vue&type=script&setup=true&lang=js"

import "./LaputaContactMe.vue?vue&type=style&index=0&id=045b9b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045b9b0e"]])

export default __exports__